"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.combineURLs = exports.typeStreamID = void 0;
const streamid_1 = __importDefault(require("@ceramicnetwork/streamid"));
function typeStreamID(streamId) {
    return typeof streamId === 'string' ? streamid_1.default.fromString(streamId) : streamId;
}
exports.typeStreamID = typeStreamID;
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
exports.combineURLs = combineURLs;
async function delay(mills) {
    await new Promise((resolve) => setTimeout(() => resolve(), mills));
}
exports.delay = delay;
//# sourceMappingURL=utils.js.map